import api from './api';

// Get all apps for the current user
const getApps = async () => {
  try {
    const response = await api.get('/app/list');
    return response.data;
  } catch (error) {
    console.error('Get apps error:', error);
    throw error;
  }
};

// Create a new app
const createApp = async (name) => {
  try {
    const response = await api.post('/app/create', { name });
    return response.data;
  } catch (error) {
    console.error('Create app error:', error);
    throw error;
  }
};

// Delete an app
const deleteApp = async (appId) => {
  try {
    const response = await api.post('/app/delete', { appId });
    return response.data;
  } catch (error) {
    console.error('Delete app error:', error);
    throw error;
  }
};

// Get MAU stats for an app
const getMauStats = async (appId, startDate = null, endDate = null) => {
  try {
    const params = { appId: appId.toString() };
    
    if (startDate) {
      params.startDate = startDate.toISOString();
    }
    
    if (endDate) {
      params.endDate = endDate.toISOString();
    }
    
    const response = await api.get('/app/mau/stats', { params });
    
    // Log the response for debugging
    console.log('MAU stats API response:', response.data);
    
    // Validate the response structure
    if (!response.data || !response.data.stats) {
      console.error('Invalid MAU stats response structure:', response.data);
      throw new Error('Invalid MAU stats response structure');
    }
    
    // Validate the stats object
    const { stats } = response.data;
    if (stats.totalMau === undefined || stats.totalMau === null) {
      console.warn('MAU stats missing totalMau value:', stats);
    }
    
    return response.data;
  } catch (error) {
    console.error('Get MAU stats error:', error);
    throw error;
  }
};

const AppService = {
  getApps,
  createApp,
  deleteApp,
  getMauStats
};

export default AppService;